module.exports = __webpack_public_path__ + "img/南通三六五二手车交易市场有限公司.67147918.jpg";